/* eslint-disable @typescript-eslint/no-explicit-any */

import { TFunction } from "i18next";

import { SvgIcon } from "@/components/Icon/SvgIcon";
import { TableColumn } from "@/components/Table/Table";

import { ReactComponent as downloadIcon } from "@assets/icons/download.svg";
import { ReactComponent as trash } from "@assets/icons/create-list/trash.svg";

import { TrackerSourceType } from "@/enum/tracker.enum";

export const getCustomTableColumns = ({
	type,
	downloadIsLoading,
	handleDownload,
	handleDeleteModal,
}: {
	type: TrackerSourceType;
	downloadIsLoading: boolean;
	handleDownload?: (row: any) => void;
	handleDeleteModal?: (row: any) => void;
	handleRemove?: (row: any) => Promise<void>;
	handlePreviewModal?: (row: any) => Promise<void>;
	t: TFunction<"translation">;
}) => {
	const columns: TableColumn[] = [
		{
			title: "name",
			uid: "name",
			allowExclude: false,
			hideable: false,
			moveable: false,
			show: true,

			render: (row: any) => <div className="max-w-[350px] truncate">{row.name}</div>,
		},
		{
			title: "",
			uid: "action",
			allowExclude: false,
			hideable: false,
			moveable: false,
			show: true,

			render: (row: any) => (
				<div className="flex items-center w-full justify-end">
					<SvgIcon
						className="min-w-[20px] h-[20px] cursor-pointer text-gray-700 ml-1"
						svgIcon={downloadIcon}
						onClick={() => {
							!downloadIsLoading && handleDownload?.(row);
						}}
					/>
					<SvgIcon
						className="min-w-[20px] h-[20px] cursor-pointer text-gray-700 ml-2"
						svgIcon={trash}
						onClick={() => {
							handleDeleteModal?.(row);
						}}
					/>
				</div>
			),
		},
	];

	if (type === TrackerSourceType.XLSX) {
		return columns;
	}
};
